import { Dialog } from '@headlessui/react'
import CogIcon from '@heroicons/react/outline/CogIcon'
import FullscreenExitLineIcon from 'remixicon-react/FullscreenExitLineIcon'
import FullscreenLineIcon from 'remixicon-react/FullscreenLineIcon'

import { XIcon } from '@tribeplatform/react-ui-kit/icons'
import { useModal } from '@tribeplatform/react-ui-kit/Modal'

export const PostModalHeader = ({
  title,
  onSettingsClick,
  showSettings,
  rightContent,
}) => {
  const { onClose, size, toggleZenMode } = useModal()

  return (
    <div className="px-4 py-5 sm:p-6 flex justify-between pb-0 sm:pb-0 items-center w-full max-w-2xl mx-auto">
      <div className="text-center sm:mt-0 sm:text-left">
        <Dialog.Title as="h3" className="text-basicSurface-900">
          {title}
        </Dialog.Title>
      </div>

      {rightContent || (
        <div className="space-x-3 flex items-center">
          {showSettings && (
            <button
              tabIndex={0}
              type="button"
              className="bg-surface-50 rounded-md text-basicSurface-400 hover:text-basicSurface-500 focus:outline-none focus-visible:ring"
              onClick={onSettingsClick}
            >
              <CogIcon className="h-6 w-6" />
            </button>
          )}
          <button
            tabIndex={0}
            type="button"
            className="hidden sm:block bg-surface-50 rounded-md text-basicSurface-400 hover:text-basicSurface-500 focus:outline-none focus-visible:ring"
            onClick={toggleZenMode}
          >
            <span className="sr-only">Zen Mode</span>
            {size !== 'zen' ? (
              <FullscreenLineIcon className="h-6 w-6" aria-hidden="true" />
            ) : (
              <FullscreenExitLineIcon className="h-6 w-6" aria-hidden="true" />
            )}
          </button>
          <button
            tabIndex={0}
            type="button"
            className="bg-surface-50 rounded-md text-basicSurface-400 hover:text-basicSurface-500 focus:outline-none focus-visible:ring"
            onClick={onClose}
          >
            <span className="sr-only">Close</span>
            <XIcon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
      )}
    </div>
  )
}
